import React from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import {
  Event,
  Identifiable,
  List as L,
  Milestone,
  Project,
  Task,
} from "@planzone/dto";

import { useModal } from "@root/client/modal";
import { SelectList } from "@common/selectList";
import { Props } from "./types";
import { List } from "./list";
import styles from "./styles.scss";

function isElDone(
  el:
    | Identifiable<Project>
    | Identifiable<Task>
    | Identifiable<L>
    | Identifiable<Event>
    | Identifiable<Milestone>,
  type: "TASK" | "ACTIVITY" | "MILESTONE",
) {
  return type === "TASK"
    ? (el as Identifiable<Task>).percentComplete === 100
    : type === "MILESTONE" && (el as Identifiable<Milestone>).state === "DONE";
}

function ConstraintsPopup({
  direction = "left",
  constraintsNbr,
  ...props
}: Props) {
  const ref = React.useRef<HTMLDivElement>(null);

  return constraintsNbr > 0 ? (
    <div ref={ref}>
      <SelectList
        listClassName={classNames(styles.listRoot, {
          [styles.left]: direction === "left",
          [styles.right]: direction === "right",
        })}
      >
        {({ isOpen }) => {
          const rect = ref.current?.getBoundingClientRect();

          return {
            input: (
              <div
                className={classNames(styles.input, {
                  [styles.active]: isOpen,
                })}
              >
                <p className={styles.nbr}>{constraintsNbr}</p>
                <svg width="11.021" height="8.972" viewBox="0 0 11.021 8.972">
                  <g transform="translate(0.75 0.75)">
                    <line
                      x2="7.172"
                      fill="none"
                      stroke="#fff"
                      strokeLinecap="round"
                      strokeWidth="1.5"
                    />
                    <line
                      y1="7.172"
                      transform="translate(7.172)"
                      fill="none"
                      stroke="#fff"
                      strokeLinecap="round"
                      strokeWidth="1.5"
                    />
                    <line
                      x1="2.049"
                      y1="1.537"
                      transform="translate(5.123 5.635)"
                      fill="none"
                      stroke="#fff"
                      strokeLinecap="round"
                      strokeWidth="1.5"
                    />
                    <line
                      y1="1.537"
                      x2="2.049"
                      transform="translate(7.172 5.635)"
                      fill="none"
                      stroke="#fff"
                      strokeLinecap="round"
                      strokeWidth="1.5"
                    />
                  </g>
                </svg>
              </div>
            ),
            list:
              props.portal && rect ? (
                createPortal(
                  <div
                    className={styles.portalList}
                    style={{
                      top: rect.bottom + 10,
                      ...(direction === "left"
                        ? {
                            right:
                              document.documentElement.clientWidth - rect.right,
                          }
                        : { left: rect.left }),
                    }}
                  >
                    <List
                      project={props.project}
                      elementId={props.elementId}
                      elementType={props.elementType}
                    />
                  </div>,
                  document.body,
                )
              ) : (
                <List
                  project={props.project}
                  elementId={props.elementId}
                  elementType={props.elementType}
                />
              ),
          };
        }}
      </SelectList>
    </div>
  ) : (
    <React.Fragment />
  );
}

export { ConstraintsPopup };
